import { Injectable } from '@angular/core';
import { OpportunityType } from '@shared/models/opportunity';

/**
 * Planner-specific service to provide opportunityType synchronously to the interceptor
 * This avoids race conditions when opening modals from the planner before the full
 * opportunity summary is loaded.
 * 
 * Only used by planner modals - does not affect other parts of the application.
 */
@Injectable({
  providedIn: 'root'
})
export class PlannerOpportunityTypeService {
  private _opportunityType: OpportunityType | null = null;

  /**
   * Set the opportunity type (called by planner before opening modal)
   */
  setOpportunityType(opportunityType: OpportunityType | null): void {
    this._opportunityType = opportunityType;
  }

  /**
   * Get the opportunity type (called by interceptor)
   * Returns null if not set (normal flow for non-planner code)
   */
  getOpportunityType(): OpportunityType | null {
    return this._opportunityType;
  }

  /**
   * Clear the opportunity type (called after modal closes or on cleanup)
   */
  clear(): void {
    this._opportunityType = null;
  }
}

